<mat-form-field *transloco="let t" appearance="standard" class="w-100">
    <mat-label>{{ label }}</mat-label>
    <input matInput [formControl]="innerControl" type="text" [placeholder]="placeholder" />
    <mat-error><td-validation-messages *ngIf="innerControl.invalid" [control]="innerControl" [context]="{ name: label }"></td-validation-messages></mat-error>
    <mat-hint *ngIf="resolvedAddress">{{ t('recipient.resolved-address-info', { address: resolvedAddress }) }}</mat-hint>
    <mat-progress-spinner matSuffix *ngIf="resolving" [diameter]="20" mode="indeterminate"></mat-progress-spinner>
</mat-form-field>
